export default "__VITE_ASSET__CpAE7NP$__"